'use strict';

import {
	Box3, DoubleSide,
	ExtrudeGeometry,
	Mesh,
	MeshBasicMaterial,
	Shape, Spherical,
	Vector3,
} from 'three';
import { EXTRUDE_SETTINGS, FLOOR_HEIGHT, SCHEMATIC_SCALE } from './SchematicBuildingModel';
import { Polygon } from '../../../libs/Polygon';
import { polyLabel } from '../../../libs/PolyLabel';
import { Text } from '../../components/preloader/DreamsSlider/Text/Troika';

const _axis = new Vector3(1,0,0);

export class Apartment {
	constructor (points,props) {
		this.points = removeDuplicate(points);
		this.props = props;
		this.holes = [];
		this.mesh = null;
		this.outPath = null;
	}
	
	createMesh() {
		const _halfFloor = FLOOR_HEIGHT / 2;
		
		const poly = new Polygon(this.points);
		poly.offset(-0.3,1);
		const points = poly.getPoints();

		const polyArray = this.points.map(vec => vec.toArray());

		const label = polyLabel([polyArray]);
		const centroid = new Vector3(label[0],label[1],0);
		centroid.multiplyScalar(SCHEMATIC_SCALE);
		centroid.applyAxisAngle(_axis,-Math.PI / 2);
		centroid.y = 0;

		const shape = new Shape(points);
		shape.holes = this.holes;
		
		const geometry = new ExtrudeGeometry(shape,EXTRUDE_SETTINGS);
		geometry.rotateX(-Math.PI / 2);
		geometry.scale(SCHEMATIC_SCALE,1,SCHEMATIC_SCALE);
		geometry.computeBoundingBox();
		const center = new Vector3();
		geometry.boundingBox.getCenter(center);
		center.y = 0;
		const labelPos = new Vector3();
		
		if (this.holes.length) {
			const shapeV3 = points.map(vec2 => new Vector3(vec2.x,0,vec2.y).multiplyScalar(SCHEMATIC_SCALE));
			const shapeSize = new Vector3();
			const holeSize = new Vector3();
			const boxHoles = new Box3();
			const boxShape = new Box3();
			const {holes} = shape.extractPoints();
			const holesV3 = holes[0].map(vec2 => new Vector3(vec2.x,0,vec2.y).multiplyScalar(SCHEMATIC_SCALE));
			boxHoles.setFromPoints(holesV3);
			boxHoles.getSize(holeSize);
			boxShape.setFromPoints(shapeV3);
			boxShape.getSize(shapeSize);
			labelPos.x = (shapeSize.x / 2 + holeSize.x / 2) / 2;
		}
		const geoPosition = new Vector3().subVectors(center,centroid).sub(labelPos);

		geometry.center();
		geometry.translate(geoPosition.x,_halfFloor,geoPosition.z);

		const material = new MeshBasicMaterial({color: '#ffdada',transparent: true,
			opacity: 1,
			depthWrite: false,
			depthTest: true});
		this.mesh = new Mesh(geometry,material);
		this.mesh.position.copy(centroid).add(labelPos);
		this.mesh.name = this.props.engineId;
		
		const curvesLength = this.outPath.curves.map(curve => curve.v1.distanceTo(curve.v2));
		const maxLength = Math.max(...curvesLength);
		const curveIndex = curvesLength.indexOf(maxLength);
		const curve = this.outPath.curves[curveIndex];
		
		const curveStart = new Vector3().set(curve.v1.x,curve.v1.y,0);
		curveStart.applyAxisAngle(_axis,-Math.PI / 2);
		curveStart.multiplyScalar(SCHEMATIC_SCALE);
		curveStart.y = _halfFloor;
		
		const curveEnd = new Vector3().set(curve.v2.x,curve.v2.y,0);
		curveEnd.applyAxisAngle(_axis,-Math.PI / 2);
		curveEnd.multiplyScalar(SCHEMATIC_SCALE);
		curveEnd.y = _halfFloor;
		
		const curveCenter = curve.getPoint(0.5);
		const vec3 = new Vector3().set(curveCenter.x,curveCenter.y,0);
		vec3.applyAxisAngle(_axis,-Math.PI / 2);
		vec3.multiplyScalar(SCHEMATIC_SCALE);
		vec3.y = _halfFloor;
		
		this.mesh.worldToLocal(vec3);
		const text = new Text();
		text.material = new MeshBasicMaterial({ side: DoubleSide});
		text.fontSize = 2;
		text.color = '#ffffff';
		text.anchorX = 'center';
		text.anchorY = 'middle';
		text.font = './fonts/assistant/Assistant-Regular.woff';
		text.text = this.props.propNum;
		text.position.copy(vec3);
		text.name = 'AptNum';
		text.visible = false;
		this.mesh.add(text);
		const direction = new Vector3().subVectors(curveStart,curveEnd).normalize();
		const spherical = new Spherical().setFromVector3(direction);
		text.rotation.y = spherical.theta - Math.PI / 2;
		text.sync();
		

		return this.mesh;
	}
}

function removeDuplicate (points) {
	const uniquePoints = new Set();
	const result = [];
	
	points.forEach(point => {
		if (![...uniquePoints].some(p => p.equals(point))) {
			uniquePoints.add(point);
			result.push(point);
		}
	});
	
	result.push(result[0]);
	
	return result;
}
